import gql from "graphql-tag";

export default gql`query DescriptionsSales {
    descriptionsSales {
        id
        body
    }
  }`